import { FileRecord } from "@/shared/domain/files";
import { TopicRecord } from "@/shared/domain/topics";
import { Dataset, DataGridSortingOrder, SearchQueryBody } from "@/types";

type RowsPerPage = 10 | 25 | 50;

export interface TablePageState {
  modalOpen: boolean;
  rightClickedRow: Dataset | FileRecord | TopicRecord | null;
  sidebar: {
    isOpen: boolean;
    dataset: Dataset | null;
  };
  columns: string[];
  rowsPerPage: RowsPerPage;
  snackbar: {
    isOpen: boolean;
    message: string;
  };
  sortColumnIndex: number | null;
  sortOrder: DataGridSortingOrder;
  lastSearchQuery: SearchQueryBody;
  selectedRows: Set<string>;
  preferencesLoaded: boolean;
}

export type TablePageAction =
  | {
      type: "SET_MODAL_OPEN";
      payload: boolean;
    }
  | {
      type: "SET_RIGHT_CLICKED_ROW";
      payload: Dataset | null;
    }
  | {
      type: "SET_SIDEBAR_OPEN";
      payload: {
        isOpen: boolean;
        dataset: Dataset | null;
      };
    }
  | {
      type: "SAVE_COLUMNS";
      payload: string[];
    }
  | {
      type: "SET_TABLE_CONFIG";
      payload: {
        rowsPerPage: RowsPerPage;
      };
    }
  | {
      type: "LOAD_PREFERENCES";
      payload: {
        columns: string[];
        rowsPerPage: RowsPerPage;
      };
    }
  | {
      type: "SET_SNACKBAR";
      payload: {
        isOpen: boolean;
        message: string;
      };
    }
  | {
      type: "SET_SELECTED_ROWS";
      payload: {
        selectedRows: Set<string>;
      };
    };

export const tablePageReducer = (
  state: TablePageState,
  action: TablePageAction,
): TablePageState => {
  switch (action.type) {
    case "SET_MODAL_OPEN":
      return {
        ...state,
        modalOpen: action.payload,
      };

    case "SET_RIGHT_CLICKED_ROW":
      return {
        ...state,
        rightClickedRow: action.payload,
      };

    case "SET_SIDEBAR_OPEN":
      return {
        ...state,
        sidebar: {
          isOpen: action.payload.isOpen,
          dataset: action.payload.dataset,
        },
      };

    case "SAVE_COLUMNS":
      return {
        ...state,
        columns: action.payload,
        modalOpen: false,
      };

    case "SET_TABLE_CONFIG":
      return {
        ...state,
        rowsPerPage: action.payload.rowsPerPage,
      };

    case "LOAD_PREFERENCES":
      return {
        ...state,
        columns: action.payload.columns,
        rowsPerPage: action.payload.rowsPerPage,
        preferencesLoaded: true,
      };

    case "SET_SNACKBAR":
      return {
        ...state,
        snackbar: {
          isOpen: action.payload.isOpen,
          message: action.payload.message,
        },
      };

    case "SET_SELECTED_ROWS":
      return {
        ...state,
        selectedRows: action.payload.selectedRows,
      };
  }
};
